import './apps.css';

function normalizeColor(input) {
  if (!input) return '';
  if (typeof input === 'string') return input;
  if (typeof input === 'object') {
    return input.current || input.initial || '';
  }
  return '';
}

function getSrc(app) {
  return app?.src || app?.param?.src || app?.config?.url || app?.raw?.asset?.link || '';
}

function formatHost(url) {
  try {
    const u = new URL(url);
    return u.host;
  } catch {
    return url;
  }
}

/**
 * WebApp: render halaman web via iframe.
 * Menghormati config param (backgroundColor, scroll, dll).
 */
export default function WebApp({ app }) {
  const src = String(getSrc(app) || '').trim();
  const bg = normalizeColor(app?.param?.backgroundColor) || '#000';
  const allowScroll = app?.param?.scroll !== false;

  if (!src) {
    return (
      <div className="appFallback" role="note">
        (web app: missing src)
      </div>
    );
  }

  return (
    <div className="appContainer" style={{ background: bg }}>
      <iframe
        className="appFrame"
        title={String(app?.title || 'Web App')}
        src={src}
        loading="eager"
        referrerPolicy="no-referrer"
        allow="autoplay; fullscreen"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-presentation"
        scrolling={allowScroll ? 'yes' : 'no'}
      />
      <div className="appBadge">{formatHost(src)}</div>
    </div>
  );
}
